function faqDropdown() {
	const dropdowns = document.querySelectorAll(".dropdown-toggle");
	for (let i = 0; i < dropdowns.length; i++) {
		const dropdown = dropdowns[i];
		const plusIcon = dropdown.querySelector('img[src*="icon-circled-plus"]');
		const minusIcon = dropdown.querySelector('img[src*="icon-circled-minus"]');
		const content = dropdown.nextElementSibling;
		dropdown.addEventListener("click", function () {
			if (content.classList.contains("open")) {
				minusIcon.style.transform = "rotate(-45deg)";
				setTimeout(function () {
					plusIcon.style.display = "block";
					minusIcon.style.display = "none";
					plusIcon.style.transform = "rotate(0deg)";
				}, 300);
			} else {
				plusIcon.style.transform = "rotate(45deg)";
				setTimeout(function () {
					minusIcon.style.display = "block";
					plusIcon.style.display = "none";
					minusIcon.style.transform = "rotate(0deg)";
				}, 300);
			}
			content.classList.toggle("open");
		});
	}
}

faqDropdown();
